import React from 'react'; // Add React import
import { Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types'; // Add PropTypes import

export function RequireAuth({ children }) {
  const isAuthenticated = localStorage.getItem('token') != null;
  const location = useLocation();
  
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }
  return children;
}

// Add prop type validation
RequireAuth.propTypes = {
  children: PropTypes.node.isRequired
};

export default RequireAuth;